<template>
  <div
    class="add-card"
    @click="addCard"
    :class="isCardDisabled ? 'card-diabled' : ''"
  >
    <span class="el-icon-plus"></span>
    <div class="add-card-content">
      <p class="add-card-title">
        {{ paymentsExtraInfo.payment_name || paymentsExtraInfo.channelName }}
      </p>
      <p class="add-card-text">
        {{
          paymentsExtraInfo.supportCardType &&
          paymentsExtraInfo.supportCardType.show_msg
        }}
      </p>
    </div>
  </div>
</template>

<script>
// for development
// import WebappPay from '@didi/ibt-cashier-js/dist/index.common';
import stopper from '@/utils/stopper';
import WebappPay from '@didi/ibt-cashier-js';
import { mapActions, mapState } from 'vuex';
import { payOptions } from '@/utils/payOptions';
import { pay_add_card_ck_log } from '@/omega/business/pay';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      paymentsExtraInfo: ({ pay }) => pay.paymentsExtraInfo,
    }),
    isCardDisabled() {
      return Number(this.paymentsExtraInfo?.isDisplay) === 0;
    },
  },
  async mounted() {
    await this.getToken();
  },
  methods: {
    ...mapActions('common', ['getToken']),
    async addCard() {
      if (this.isCardDisabled) return;
      stopper.end();
      pay_add_card_ck_log();
      const params = {
        ...(await payOptions()),
        hideToast: true,
      };
      WebappPay.bindCard(params, () => {
        this.$emit('update');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-card {
  display: flex;
  align-items: center;
  height: 78px;
  cursor: pointer;
  .el-icon-plus {
    font-size: 20px;
    font-weight: 500;
    color: #000;
    font-family: 'DiDiSansPro-Medium';
    font-weight: 500;
    padding-left: 3px;
  }
  .add-card-content {
    margin-left: 18px;
  }
  .add-card-title {
    font-family: 'DiDiSansPro-Medium';
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 4px;
    color: #000;
  }
  .add-card-text {
    font-family: 'DiDiSans-Pro-Thin';
    font-weight: 200;
    font-size: 12px;
    line-height: 16px;
    color: #999;
  }
}
.card-diabled {
  cursor: not-allowed;
  opacity: 0.6;
  color: #999;
  .add-card-title {
    color: #999;
  }
  .el-icon-plus {
    color: #999;
  }
}
</style>
